<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="">
          <div class="x_panel">
            <h2 class="float-left"> Return Damage and not Received Item Reports</h2>
            <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>

            <button
              v-if="reportData && isPermissionExist(PERMISSIONS.RETURN_DAMAGE_RECEIVE_ITEM_REPORT_PRINT)"
              @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
              <i class="fa fa-print" v-if="!isPrinting"></i>
              <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
              {{ isPrinting ? 'Printing...' : 'Print' }}
            </button>
            <vue-excel-xlsx
              v-if="reportData && isPermissionExist(PERMISSIONS.RETURN_DAMAGE_RECEIVE_ITEM_REPORT_PRINT)"
              ref="excel"
              :data="excelData"
              :columns="excelHeader"
              :file-name="'Return Damage and not Received Item Report List'"
              :file-type="'xlsx'"
              :sheet-name="'sheetname'"
              :disabled="isPrinting"
              class="btn btn-primary btn-sm float-right"
            >
              <div
                @click.prevent="handleExportPrint('excel')"
              >
                <i class="fa fa-file-excel-o"></i>
                {{ isPrinting ? 'Preparing...' : 'Excel' }}
              </div>
            </vue-excel-xlsx>
          </div>
          <div class="row">
            <div class="col-sm-12">

              <form role="form" action="#" @submit="formSubmit" class="searchForm">
                <div class="x_panel">
                  <div class="x_content">
                    <div class="row justify-content-center">
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Vessel</label>
                          <select class="form-control" v-model="formData.vessel">
                            <option value="" selected>Select Vessel</option>
                            <option v-for="(row, key) in vessels" v-bind:value="{ id: row?.id, name: row?.name }">{{row?.name}}</option>
                          </select>
                        </div>
                      </div>

                      <!--                      <div class="col-md-2">-->
                      <!--                        <div class="form-group">-->
                      <!--                          <label>Date From</label>-->
                      <!--                          <DatePicker type="date" v-model="formData.dateFrom" valueType="format"></DatePicker>-->
                      <!--                        </div>-->
                      <!--                      </div>-->

                      <!--                      <div class="col-md-2">-->
                      <!--                        <div class="form-group">-->
                      <!--                          <label>Date To</label>-->
                      <!--                          <DatePicker type="date" v-model="formData.dateTo" valueType="format"></DatePicker>-->
                      <!--                        </div>-->
                      <!--                      </div>-->


                      <div class="col-md-2">
                        <button style="margin-top: 26px" type="submit" class="btn btn-success btn-sm">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div
                v-if="loading"
                class="col-md-12 text-center"
                style="margin-top:25%"
              >
                <PulseLoader
                  :loading="loading"
                ></PulseLoader>
              </div>
              <div class="card-box table-responsive" v-if="reportData && !loading">

                <div class="clearfix"></div>
                <div id="printableArea">
                  <div class="mb-3 text-center">
                    <div class="font-weight-bold">Return Damage and not Received Item Report</div>
                    <div>Vessel:
                      <span v-if="formData.vessel">{{formData.vessel.name}}</span>
                    </div>
                    <!--                    <div>-->
                    <!--                      Date Period:-->
                    <!--                      <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> - -->
                    <!--                      <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>-->
                    <!--                    </div>-->
                  </div>
                  <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                  <TableData
                    :reportData="reportData?.data"
                    :currentPage="Number(reportData?.current_page)"
                    :perPage="Number(reportData?.per_page)"
                  >
                  </TableData>
                  <Pagination :pagination="reportData" :getData="formSubmit"/>

                  <div id="printArea" style="display: none">
                    <div style="text-align: center">
                      <h2 style="line-height: 10px;">{{ appName }}</h2>
                      <h3 style="line-height: 10px;">Return Damage and not Received Item Report</h3>
                      <h3 style="line-height: 10px;">Vessel: <span v-if="formData.vessel">{{formData.vessel.name}}</span></h3>
                      <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                    </div>
                    <TableData :reportData="printItems" :isPrinting="true"></TableData>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import auth from "@/auth";
    import TableData from "./TableData.vue";
    import {apiPrintData, printUtil} from "@/utils/print";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";


    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        components: {TableData, DatePicker, PulseLoader},
        data() {
            return {
                loading: false,
                isPrinting: false,
                formData: {
                    vessel: {
                        id: auth.getVesselId(),
                        name: ''
                    }
                },
                appName: process.env.VUE_APP_NAME,
                quotationDetails: null,
                vessels: null,
                reportData: [],
                noDataFound: null,
                offset: 20,
                vesselId: auth.getVesselId(),
                permissions: auth.getPermissionData(),
                printItems: [],
                excelHeader: [],
                excelData: [],
            }
        },
        mounted() {
            this.getVessel();
            this.formSubmit();
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel
                  const selectedVessel = this.vessels.find(vessel => vessel.id == this.vesselId);
                  if (selectedVessel) {
                    this.formData.vessel = {
                      id: selectedVessel.id,
                      name: selectedVessel.name
                    };
                  }
                }).catch(e => {
                    console.log(e)
                })
            },

            onPerPageChange() {
              this.formSubmit(1);
            },
          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Item Name': `${item?.item?.name || ''}`,
                'Impa Code': `${item?.item?.inpa_code || ''}`,
                'Model': `${item?.item?.model || ''}`,
                'RFQ No': `${item?.purchase?.requisition?.requisition_no || ''}`,
                'P.O No': `${item?.purchase?.po_no || ''}`,
                'Order Qty': `${item?.order_qty || ''}`,
                'Receive Qty': `${item?.qty || ''}`,
                'Return Qty': `${item?.returned_qty || ''}`,
                'Damage Qty': `${item?.damage_qty || ''}`,
                'Status': `${item?.status == 1 ? 'Receive' : 'Not Received'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.formData.vessel_id,
                is_all: 1,
              };

              const res = await this.$http.get('/api/report/return-damage-item', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Return Damage and not Received Item Report List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            async handlePrint() {
              this.isPrinting = true;

              try {
                const params = {
                  vessel_id: this.formData.vessel_id,
                  is_all: 1,
                };

                const res = await this.$http.get('/api/report/return-damage-item', {params});
                this.printItems = res?.data?.success ?? [];

                this.$nextTick(() => {
                  apiPrintData('printArea', 'Return Damage Item Report List');
                  this.isPrinting = false;
                });

              } catch (error) {
                this.isPrinting = false;
                printWindow.close();
              }
            },

            formSubmit(page = 1) {
                this.loading = true;
                if (this.formData.vessel) this.formData.vessel_id = this.formData.vessel.id;
                let params = {
                    vessel_id: this.formData.vessel_id,
                    is_all: 0,
                    page: page,
                    offset: this.offset,
                };
                this.$http.get('/api/report/return-damage-item', {params}).then((response) => {
                    this.loading = false;
                    this.reportData = response.data.success;
                }).catch((e) => {
                    this.loading = false;
                    let response = e?.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        console.log(e)
                    }
                })
            },
            show(id) {
                this.$http.get('/api/quotation/' + id).then(response => {
                    this.quotationDetails = response.data;
                    $('#quotationModal').modal('show');
                }).catch(e => {
                    console.log(e)
                })
            },
        }
    }
</script>

<style scoped>

</style>
